import React from 'react';
const BusinessInfoStep = ({
  onNext
}) => {
  const handleSubmit = e => {
    e.preventDefault();
    onNext();
  };
  return <div data-id="element-612">
      <h2 className="text-xl font-semibold mb-6" data-id="element-613">Business Information</h2>
      <form onSubmit={handleSubmit} data-id="element-614">
        <div className="space-y-6" data-id="element-615">
          <div data-id="element-616">
            <label htmlFor="businessName" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-617">
              Business Name
            </label>
            <input type="text" id="businessName" name="businessName" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter your legal business name" required data-id="element-618" />
          </div>
          <div data-id="element-619">
            <label htmlFor="businessType" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-620">
              Business Type
            </label>
            <select id="businessType" name="businessType" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" required data-id="element-621">
              <option value="" data-id="element-622">Select business type</option>
              <option value="retail" data-id="element-623">Retail</option>
              <option value="service" data-id="element-624">Service</option>
              <option value="online" data-id="element-625">Online Shop</option>
              <option value="restaurant" data-id="element-626">Restaurant</option>
              <option value="other" data-id="element-627">Other</option>
            </select>
          </div>
          <div data-id="element-628">
            <label htmlFor="address" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-629">
              Business Address
            </label>
            <input type="text" id="address" name="address" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 mb-2" placeholder="Address line" required data-id="element-630" />
            <div className="grid grid-cols-2 gap-4" data-id="element-631">
              <input type="text" id="city" name="city" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="City" required data-id="element-632" />
              <input type="text" id="postalCode" name="postalCode" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Postal code" required data-id="element-633" />
            </div>
          </div>
          <div data-id="element-634">
            <label htmlFor="taxId" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-635">
              Tax ID / Registration Number
            </label>
            <input type="text" id="taxId" name="taxId" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter your business tax ID or registration number" required data-id="element-636" />
          </div>
          <div data-id="element-637">
            <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-638">
              Business Email
            </label>
            <input type="email" id="email" name="email" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter your business email" required data-id="element-639" />
          </div>
          <div data-id="element-640">
            <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-641">
              Business Phone
            </label>
            <input type="tel" id="phone" name="phone" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter your business phone number" required data-id="element-642" />
          </div>
          <div className="pt-4" data-id="element-643">
            <button type="submit" className="w-full px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-644">
              Continue to Account Information
            </button>
          </div>
        </div>
      </form>
    </div>;
};
export default BusinessInfoStep;